import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["group"]

  connect() {
    this.currentIndex = 0
    this.showGroup(0)
    this.startAutoRotate()
  }

  disconnect() {
    this.stopAutoRotate()
  }

  startAutoRotate() {
    this.timer = setInterval(() => { this.next() }, 20000)
  }

  stopAutoRotate() {
    if (this.timer) clearInterval(this.timer)
  }

  next() {
    this.stopAutoRotate()
    this.currentIndex = (this.currentIndex + 1) % this.groupTargets.length
    this.showGroup(this.currentIndex)
    this.startAutoRotate()
  }

  previous() {
    this.stopAutoRotate()
    this.currentIndex = (this.currentIndex - 1 + this.groupTargets.length) % this.groupTargets.length
    this.showGroup(this.currentIndex)
    this.startAutoRotate()
  }

  goTo(event) {
    this.stopAutoRotate()
    this.currentIndex = parseInt(event.currentTarget.dataset.index)
    this.showGroup(this.currentIndex)
    this.startAutoRotate()
  }

  showGroup(index) {
    this.groupTargets.forEach((group, i) => {
      if (i === index) {
        group.classList.remove("hidden", "opacity-0")
        group.classList.add("opacity-100")
      } else {
        group.classList.add("hidden", "opacity-0")
        group.classList.remove("opacity-100")
      }
    })

    // Update dots
    this.element.querySelectorAll("[data-dot]").forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("bg-slate-800")
        dot.classList.remove("bg-slate-300")
      } else {
        dot.classList.remove("bg-slate-800")
        dot.classList.add("bg-slate-300")
      }
    })
  }
}
